import io from 'socket.io-client';
export default {
  data: function () {
    return {
      hiveTwinSocket: null,
    };
  },
  destroyed() {
    this.teardownDtwinSocket();
  },
  methods: {
    teardownDtwinSocket() {
      if (this.hiveTwinSocket) {
        this.hiveTwinSocket.close();
      }
    },
    setupDtwinSocket(dtwinId) {
      if (dtwinId) {
        const hiveTwinSocket = io(`${location.origin}/dtwin/${dtwinId}/states`, {
          path: '/api/v1/socket.io',
          allowEIO3: true,
        });

        const instance = this;
        hiveTwinSocket.on('update', function (data) {
          if (instance.statesValuesUpdated) {
            instance.statesValuesUpdated(data.states);
          }
        });

        hiveTwinSocket.on('connect_error', function (error) {
          console.error('Socket connection error:', error);
        });

        hiveTwinSocket.on('error', function (error) {
          console.error('Socket error:', error);
        });

        this.hiveTwinSocket = hiveTwinSocket;
      }
    },
  },
};
